import { FieldType } from '../../../models/field/field-type.enum';

export class MultiDocEditDialogModel {
  dialogInfo: MultiDocEditDialogInfo;
  multiDocGroups: any[];
  totalDocsSelected: number;
  expandEmailFamilySelected: boolean;
  isDocViewer?: boolean;
}

export interface MultiDocEditDialogInfo {
  dialogTitle: string;
  fieldId: string;
  fieldType: FieldType;
}
